import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';
import { DateRangePicker } from 'react-dates';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { staticColumns, statusList } from '@features/crm/utils/helpers';
import { toggleCheckbox } from '@features/filter/static/filterUtil';

import { fetchAccountManagerList } from '@store/actions/AccountManagerAction';
import { clearGlobalFilter, storeItemInGlobalFilter } from '@store/actions/FilterAction';
import { closeLoader, openLoader } from '@store/actions/LoaderAction';
import { fetchPONumberList } from '@store/actions/OrderDashboardFilterAction';
import { fetchProjectManagerList } from '@store/actions/ProjectManagerAction';

const OrderTabFilters = () => {
	const filterData = useSelector((store) => store.filterFieldStore);
	const poList = useSelector((store) => store.orderPOStore);
	const userList = useSelector((store) => store.projectManagerStore);
	const acManagerList = useSelector((store) => store.acManagerStore);
	const filterFields = useSelector((store) => store.filterFieldStore);
	const [users, setUsers] = useState([]);
	const [acManagers, setAcManagers] = useState([]);
	const [fieldName, setFieldName] = useState(null);
	const [fromDate, setFromDate] = useState('');
	const [toDate, setToDate] = useState('');
	const [focusedInput, setFocusedInput] = useState(null);
	const orderStageRef = useRef();
	const orderStatusRef = useRef();
	const etdRef = useRef();
	const poNumberRef = useRef();
	const pmRef = useRef();
	const acManagerRef = useRef();
	const dispatch = useDispatch();
	const { id } = useParams();

	const onChangeDateRange = async (name, type, paramName1, paramName2, value1, value2) => {
		let dateRange = {
			name: 'buyerETD',
			type: 'dateRange',
			key: value1 + ',' + value2,
			value: value1 + ' - ' + value2,
			identifier: 'buyerETDFilterDateRange'
		};
		dispatch(storeItemInGlobalFilter(dateRange));
	};

	const saveDate = async (startDate, endDate) => {
		let from = startDate ? startDate.format('YYYY-MM-DD') : null;
		let to = endDate ? endDate.format('YYYY-MM-DD') : null;
		setFromDate(from);
		setToDate(to);
		if (startDate && endDate) {
			await onChangeDateRange('dateRangePicker', 'dateRange', 'buyerEtdFrom', 'buyerEtdTo', from, to);
		}
	};

	useEffect(() => {
		setUsers(userList);
	}, [userList]);

	useEffect(() => {
		setAcManagers(acManagerList);
	}, [acManagerList]);

	useEffect(() => {
		document.addEventListener('mousedown', handleClickOutside);
		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, [fieldName]);

	useEffect(() => {
		dispatch(fetchAccountManagerList());
		dispatch(fetchProjectManagerList());
		dispatch(fetchPONumberList(`&brandId=${id}`));
	}, []);

	const handleClickOutside = (event) => {
		if (orderStageRef && !orderStageRef.current.contains(event.target)) {
			if (fieldName === 'orderStage') {
				setFieldName(null);
			}
		}
		if (orderStatusRef && !orderStatusRef.current.contains(event.target)) {
			if (fieldName === 'status') {
				setFieldName(null);
			}
		}
		if (etdRef && !etdRef.current.contains(event.target)) {
			if (fieldName === 'etd') {
				setFieldName(null);
			}
		}
		if (poNumberRef && !poNumberRef.current.contains(event.target)) {
			if (fieldName === 'poNumber') {
				setFieldName(null);
			}
		}
		if (pmRef && !pmRef.current.contains(event.target)) {
			if (fieldName === 'projectManager') {
				setFieldName(null);
			}
		}
		if (acManagerRef && !acManagerRef.current.contains(event.target)) {
			if (fieldName === 'accountManager') {
				setFieldName(null);
			}
		}
	};

	const renderStages = () => {
		return staticColumns?.map((item) => {
			return (
				<div className="custom-chekbox" key={`stage_name_${item.value}`}>
					<div className="form-group">
						<input
							type="checkbox"
							id={`orderStage_${item.value}`}
							name={`orderStage_${item.value}`}
							value={item.value}
							onChange={(e) => handleCheckbox(e, item.label, 'orderStatus')}
							checked={toggleCheckbox(
								filterData,
								'orderStatus',
								`orderStage_${item.value}`,
								item.value
							)}
						/>
						<label htmlFor={`orderStage_${item.value}`}>
							<span>{item.label}</span>
						</label>
					</div>
				</div>
			);
		});
	};

	const handleFieldName = (value) => {
		if (fieldName === value) {
			setFieldName(null);
		} else {
			setFieldName(value);
		}
	};

	const handleCheckbox = (e, title, fieldName) => {
		let { value, checked, name } = e.target;
		let data = {
			name: fieldName,
			key: value,
			value: title,
			identifier: name,
			checked: checked
		};
		dispatch(storeItemInGlobalFilter(data));
	};

	const renderPOList = () => {
		return poList?.map((item) => {
			return (
				<div className="custom-chekbox" key={`filter_poNumber_${item.value}`}>
					<div className="form-group">
						<input
							type="checkbox"
							id={`poNumber_${item.value}`}
							name={`poNumber_${item.value}`}
							value={item.value}
							onChange={(e) => handleCheckbox(e, item.label, 'poIdList')}
							checked={toggleCheckbox(
								filterData,
								'poIdList',
								`poNumber_${item.value}`,
								item.value
							)}
						/>
						<label htmlFor={`poNumber_${item.value}`}>
							<span>{item.label}</span>
						</label>
					</div>
				</div>
			);
		});
	};

	const renderStatusList = () => {
		return statusList?.map((item) => {
			return (
				<div className="custom-chekbox" key={`filter_tnaStatus_${item.value}`}>
					<div className="form-group">
						<input
							type="checkbox"
							id={`tnaStatus_${item.value}`}
							name={`tnaStatus_${item.value}`}
							value={item.value}
							onChange={(e) => handleCheckbox(e, item.label, 'tnaStatus')}
							checked={toggleCheckbox(
								filterData,
								'tnaStatus',
								`tnaStatus_${item.value}`,
								item.value
							)}
						/>
						<label htmlFor={`tnaStatus_${item.value}`}>
							<span>{item.label}</span>
						</label>
					</div>
				</div>
			);
		});
	};

	const renderPMList = () => {
		return users.map((item) => {
			return (
				<div className="custom-chekbox" key={`filter_projectManager_${item.id}`}>
					<div className="form-group">
						<input
							type="checkbox"
							id={`projectManager_${item.id}`}
							name={`projectManager_${item.id}`}
							value={item.id}
							onChange={(e) => handleCheckbox(e, item.name, 'projectManagerIdList')}
							checked={toggleCheckbox(
								filterData,
								'projectManagerIdList',
								`projectManager_${item.id}`,
								item.id
							)}
						/>
						<label htmlFor={`projectManager_${item.id}`}>
							<span>{item.name}</span>
						</label>
					</div>
				</div>
			);
		});
	};

	const renderAcManagerList = () => {
		return acManagers.map((item) => {
			return (
				<div className="custom-chekbox" key={`filter_acManager_${item.id}`}>
					<div className="form-group">
						<input
							type="checkbox"
							id={`acManager_${item.id}`}
							name={`acManager_${item.id}`}
							value={item.id}
							onChange={(e) => handleCheckbox(e, item.name, 'accountManagerIdList')}
							checked={toggleCheckbox(
								filterData,
								'accountManagerIdList',
								`acManager_${item.id}`,
								item.id
							)}
						/>
						<label htmlFor={`acManager_${item.id}`}>
							<span>{item.name}</span>
						</label>
					</div>
				</div>
			);
		});
	};

	const handleSearch = async (e, type) => {
		const { value } = e.target;
		dispatch(openLoader());
		if (type === 'acManager') {
			await dispatch(
				fetchAccountManagerList(`?userTypeList=ACCOUNT_MANAGER&page=0&size=1000&search=${value}`)
			);
		}
		if (type === 'projectManager') {
			await dispatch(
				fetchProjectManagerList(`?userTypeList=PROJECT_MANAGER&page=0&size=1000&search=${value}`)
			);
		}
		if (type === 'poNumber') {
			await dispatch(fetchPONumberList(`${value}&brandId=${id}`));
		}
		dispatch(closeLoader());
	};

	const renderSearchBox = (type) => {
		return (
			<div className="form-group size36 m-0 search-filter">
				<div className="with-icon right-icon">
					<input
						type="text"
						autoComplete="off"
						placeholder="Search"
						onChange={(e) => handleSearch(e, type)}
					/>
					<span className="right-icon">
						<svg
							width="17"
							height="17"
							viewBox="0 0 17 17"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								fillRule="evenodd"
								clipRule="evenodd"
								d="M7.5 0C11.6421 0 15 3.35786 15 7.5C15 9.21015 14.4276 10.7866 13.464 12.0483L16.7071 15.2929C17.0976 15.6834 17.0976 16.3166 16.7071 16.7071C16.3466 17.0676 15.7794 17.0953 15.3871 16.7903L15.2929 16.7071L12.0483 13.464C10.7866 14.4276 9.21015 15 7.5 15C3.35786 15 0 11.6421 0 7.5C0 3.35786 3.35786 0 7.5 0ZM7.5 2C4.46243 2 2 4.46243 2 7.5C2 10.5376 4.46243 13 7.5 13C8.85114 13 10.0885 12.5128 11.0459 11.7045C11.091 11.5536 11.1738 11.412 11.2929 11.2929C11.412 11.1738 11.5536 11.091 11.7041 11.0446C12.5128 10.0885 13 8.85114 13 7.5C13 4.46243 10.5376 2 7.5 2Z"
								fill="#9AA1AF"
							/>
						</svg>
					</span>
				</div>
			</div>
		);
	};

	const isShowClear = () => {
		let cloneFilters = { ...filterFields };
		delete cloneFilters.dateRange;
		return Object.keys(cloneFilters).length > 0;
	};

	return (
		<div className="transparent-select order-dashboard-select-items d-flex">
			{isShowClear() && (
				<div className="mt-1 mr-2">
					<span
						className="clear-btn cursor-pointer mt-1 mr-1"
						onClick={() => dispatch(clearGlobalFilter())}
					>
						Clear
					</span>
				</div>
			)}
			<div className="single-select mr-12">
				<div className="select-component mb-2 position-relative" ref={orderStageRef}>
					<div className="click-box click mb-1" onClick={() => handleFieldName('orderStage')}>
						<p className="regular-14 ">Order stage</p>
						<img src={`${process.env.PUBLIC_URL}/images/chevron_down.svg`} alt="" />
					</div>
					<div
						className={`dropdown-box ${
							fieldName === 'orderStage' ? '' : 'd-none'
						} position-absolute`}
					>
						{renderStages()}
					</div>
				</div>
			</div>
			<div className="single-select mr-12">
				<div className="select-component mb-2 position-relative" ref={orderStatusRef}>
					<div className="click-box click mb-1" onClick={() => handleFieldName('status')}>
						<p className="regular-14 ">Status</p>
						<img src={`${process.env.PUBLIC_URL}/images/chevron_down.svg`} alt="" />
					</div>
					<div
						className={`dropdown-box ${fieldName === 'status' ? '' : 'd-none'} position-absolute`}
					>
						{renderStatusList()}
					</div>
				</div>
			</div>
			<div className="single-select mr-12">
				<div className="select-component mb-2 position-relative" ref={etdRef}>
					<div className="click-box click mb-1" onClick={() => handleFieldName('etd')}>
						<p className="regular-14 ">Buyer ETD</p>
						<img src={`${process.env.PUBLIC_URL}/images/chevron_down.svg`} alt="" />
					</div>
					<div
						className={`${
							fieldName === 'etd' ? '' : 'd-none'
						} position-absolute bg-white etd-date`}
					>
						<DateRangePicker
							daySize={25}
							numberOfMonths={1}
							minimumNights={0}
							displayFormat="MMM DD"
							isOutsideRange={() => false}
							startDate={fromDate ? moment(fromDate, 'YYYY-MM-DD') : null}
							startDateId="your_unique_start_date_id"
							endDate={toDate ? moment(toDate, 'YYYY-MM-DD') : null}
							endDateId="your_unique_end_date_id"
							onDatesChange={({ startDate, endDate }) => saveDate(startDate, endDate)}
							focusedInput={focusedInput}
							onFocusChange={(focusedInput) => setFocusedInput(focusedInput)}
						/>
					</div>
				</div>
			</div>
			<div className="single-select mr-12">
				<div className="select-component mb-2 position-relative" ref={poNumberRef}>
					<div className="click-box click mb-1" onClick={() => handleFieldName('poNumber')}>
						<p className="regular-14 ">PO Number</p>
						<img src={`${process.env.PUBLIC_URL}/images/chevron_down.svg`} alt="" />
					</div>
					<div
						className={`dropdown-box ${
							fieldName === 'poNumber' ? '' : 'd-none'
						} position-absolute`}
					>
						{renderSearchBox('poNumber')}
						{renderPOList()}
					</div>
				</div>
			</div>
			<div className="single-select mr-12">
				<div className="select-component account-manager mb-2 position-relative" ref={pmRef}>
					<div className="click-box click mb-1" onClick={() => handleFieldName('projectManager')}>
						<p className="regular-14 ">Project Manager</p>
						<img src={`${process.env.PUBLIC_URL}/images/chevron_down.svg`} alt="" />
					</div>
					<div
						className={`dropdown-box ${
							fieldName === 'projectManager' ? '' : 'd-none'
						} position-absolute`}
					>
						{renderSearchBox('projectManager')}
						{renderPMList()}
					</div>
				</div>
			</div>
			<div className="single-select mr-12">
				<div className="select-component account-manager mb-2 position-relative" ref={acManagerRef}>
					<div className="click-box click mb-1" onClick={() => handleFieldName('accountManager')}>
						<p className="regular-14 ">A/C</p>
						<img src={`${process.env.PUBLIC_URL}/images/chevron_down.svg`} alt="" />
					</div>
					<div
						className={`dropdown-box ${
							fieldName === 'accountManager' ? '' : 'd-none'
						} position-absolute`}
					>
						{renderSearchBox('acManager')}
						{renderAcManagerList()}
					</div>
				</div>
			</div>
		</div>
	);
};

export default OrderTabFilters;
